export default function GetCropUrlFilter(module) {
    angular.module(module || 'app')
        .filter('getCropUrl', getCropUrl);

    function getCropUrl() {
        return function (input, cropName) {
            if (!input) {
                return null;
            }

            var url = input.url || input.Url;
            if (!cropName) {
                return url;
            }
            var crops = input.crops || input.Crops;
            if (typeof (cropName) === 'object') {
                if (cropName['mode']) {
                    url = url.replace('&mode=crop', '');
                }
                var keys = Object.keys(cropName);
                var hasQueryString = url.indexOf('?') > -1;
                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    if ((key === 'height' || key === 'width') && cropName[key] > input[key]) {
                        continue;
                    }
                    url += (!hasQueryString && i === 0 ? '?' : '&') + key + '=' + cropName[key];
                }
                return url;
            }
            if (!crops) {
                if (!url)
                    return input;
                return url;
            }
            for (var i = 0; i < crops.length; i++) {
                var crop = crops[i];
                var _cropName = crop.name || crop.Name;
                if (_cropName === cropName)
                    return crop.url || crop.Url;
            }
            return url;
        }
    }
};